import { PropsWithChildren } from 'react';
import { HintProps } from './hint.types';
import { Root } from './ui/hint-root';
import { Trigger } from './ui/hint-trigger';
import { Content } from './ui/hint-content';
import { HintProvider } from './ui/hint-provider';
import { Text } from '../text';

export const Hint = ({
  text,
  children,
  side,
  align,
  showArrow,
  enabled = true,
  ...rootProps
}: PropsWithChildren<HintProps>) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <Root {...rootProps}>
      <Trigger asChild>{children}</Trigger>

      <Content side={side} align={align} showArrow={showArrow}>
        <Text align="center">{text}</Text>
      </Content>
    </Root>
  );
};

Hint.Provider = HintProvider;
